import { Component, OnInit, ViewChild,AfterViewInit, Input } from '@angular/core';
import { StaffRoleNew, User } from '@cradua/domain';

import { GatewayFacade } from './../../../../../gateway/src/lib/states/+gateway/gateway.facades';
import {AuthenticationService} from '../../../../../../apps/epims/mrsoftepims/src/app/services/auth.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApplicationDto } from '@cradua/data';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit {

  @Input() applications: ApplicationDto[];
  RoleForStaffData: StaffRoleNew[] = [];
  RoleForStaffDataMajors: StaffRoleNew[] = [];
  user: User;
  setAsdefault = true;
  unsubscribeSignal: Subject<void> = new Subject();
  // @ViewChild(DashboardNavComponent) menuDashboard: DashboardNavComponent;



  constructor(private gatewayFacade: GatewayFacade,public authServ: AuthenticationService,
    private router: Router) {

			console.log('navigate url to dashboard');

    }

  ngOnInit() {


     console.log("Reaching Dashboard");

    //this.reloadComponent();
    this.user = this.authServ.getUser();
    // let appInStorage = localStorage.getItem('Application');

    // if (appInStorage) {


    //   let allApps = JSON.parse(appInStorage);

    //   if(allApps.length === 0)
    //   {
    //     console.log('app in storage ', appInStorage)
    //     this.getApplication(this.user.SubscriberId);
    //   }


    // } else {
    //   console.log('app not storage')
    //   this.getApplication(this.user.SubscriberId);
    // }
    this.getApplication(this.user.SubscriberId);
    this.getAllStaffRole(this.user.Id);

    // if(this.menuDashboard != null)
    // {
    //   if(this.menuDashboard.user === undefined){
    //     this.menuDashboard.user = this.user
    //     this.menuDashboard.getAllStaffRole(this.user.Id);
    //   }
    // }
   console.log("Logged In Users ", this.authServ.getUser());
  }

  ngAfterViewInit() {
    ////console.log("All Roles Data on Dashboard After View Init ", this.RoleForStaffData);


    // @ViewChild(DashboardNavComponent) menuDashboard: DashboardNavComponent;
    //  if(menuDashboard != null)
    // {
    //   if(this.menuDashboard.user === undefined){
    //     this.menuDashboard.user = this.user
    //     this.menuDashboard.getAllStaffRole(this.user.Id);
    //   }
    // }
  }

  getApplication(subscriberId: string){


    // if(this.applications === null) {
    //   return;
    // }
    const  data = this.applications;;

      if(this.user != null)
      {

        console.log("Data from Application ", data);
        if( data != null && data.length === 0 && this.user.UserType === "Subscriber")
        {
          // console.log('getting to dashboard');
         //this.router.navigate(['/application']);
        }else{
          if (localStorage.getItem('Application')) {
            localStorage.removeItem('Application');
            localStorage.setItem('Application', JSON.stringify(data));
          }else{


            localStorage.setItem('Application', JSON.stringify(data));
          }





        }
      }





  }

  getAllStaffRole(staffId: string){

    ////console.log("Staff ID", staffId);
    this.gatewayFacade.genericFilterGateway("StaffRoleNew","StaffId", staffId)
    .pipe(takeUntil(this.unsubscribeSignal.asObservable()))
    .subscribe((data) => {

      if(data.length > 0)
      {


      this.RoleForStaffData = data;

      let staffroleData = this.RoleForStaffData.filter( n => n.isMajor === true);


      // let defaultMenu = this.RoleForStaffData.find(n => n.isDefault === true);
      // //console.log("Default menu ", defaultMenu);
      // if(defaultMenu !== undefined)
      // {
      //   //console.log("Default menu ", defaultMenu);
      //   this.router.navigate([ defaultMenu.link ]);
      // }


      this.RoleForStaffDataMajors = staffroleData.sort(function(a, b) {
        var nameA = a.name; // ignore upper and lowercase
        var nameB = b.name; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });



      //console.log("Staff Role In Data Main Dashboard ", this.RoleForStaffData);


      }


      // Transform Here
    });
  }

  setDefaultChanged(){

  }

  selectMenu(menu: any){

    //console.log("Selected menu ", menu);
    if(this.setAsdefault){

      let newObject = Object.assign({}, menu);
      newObject['isDefault'] = true;

      // Update StaffRoleNew

      this.gatewayFacade.update("StaffRoleNew",[newObject],[]);
    }

    // route to the route
    this.router.navigate([ menu['link'] ]);
  }

  reloadComponent() {
    //let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/dashboard']);
    }

    ngOnDestroy(): void {
      //Called once, before the instance is destroyed.
      //Add 'implements OnDestroy' to the class.
      // if(this.Sub) {
      //   this.Sub.unsubscribe();
      // }
      this.unsubscribeSignal.next();
      this.unsubscribeSignal.unsubscribe();
    }

}
